import React, { useState } from 'react';
import { Modal, Paper, TextField, Typography, Button, Box, CircularProgress } from '@mui/material';
import { login } from '../../services/authService';
import { useNavigate } from 'react-router-dom';

const LoginModal = ({ open, onClose }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false); // New loading state
    const navigate = useNavigate();

    const handleSubmit = async () => {
        setLoading(true); // Start loading
        setErrorMessage(""); // Clear any previous errors

        try {
            const result = await login(email, password);

            if (result.success) {
                navigate('/dashboard');
            } else {
                setErrorMessage(result.message);
            }
        } catch (error) {
            setErrorMessage("Erreur de connexion. Veuillez réessayer.");
        } finally {
            setLoading(false); // Stop loading after API response
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Paper
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 300,
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Connexion
                </Typography>
                {errorMessage && <Typography color="error">{errorMessage}</Typography>}
                
                <TextField 
                    label="Email" 
                    variant="outlined" 
                    fullWidth 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading} // Disable when loading
                />
                <TextField 
                    label="Mot de passe" 
                    type="password" 
                    variant="outlined" 
                    fullWidth 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading} // Disable when loading
                />
                
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={handleSubmit} 
                        disabled={loading} // Disable button when loading
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : "Accéder à mon compte"}
                    </Button>
                    <Button variant="text" onClick={onClose} disabled={loading}>
                        Annuler
                    </Button>
                </Box>
            </Paper>
        </Modal>
    );
};

export default LoginModal;